import _defineProperty from "@babel/runtime/helpers/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import React from "react";
import { ResponsiveImage } from "./responsive-image";
/**
 * This component can be used for adding image gallery on the story page.
 *
 * Example
 * ```javascript
 * import { ImageGalleryElement } from "@quintype/components";
 *
 * <ImageGalleryElement element={element} key={element.id} imageAspectRatio={[4,3]} />
 * ```
 * @category Story Page
 * @component
 */

export function ImageGalleryElement(_ref) {
  var className = _ref.className,
      imageAspectRatio = _ref.imageAspectRatio,
      defaultWidth = _ref.defaultWidth,
      element = _ref.element,
      widths = _ref.widths,
      story = _ref.story,
      onClickHandler = _ref.onClickHandler,
      imgParams = _ref.imgParams;
  element = element || {};
  var images = element["story-elements"].map(function (image, index) {
    return /*#__PURE__*/React.createElement("figure", {
      "data-test-id": "story-element-image-container",
      key: image.id,
      className: "story-element-image-gallery__image-container ".concat(onClickHandler ? "custom-cursor" : ""),
      onClick: function onClick() {
        return onClickHandler && onClickHandler(index);
      }
    }, /*#__PURE__*/React.createElement(ResponsiveImage, {
      slug: image["image-s3-key"],
      metadata: image["metadata"],
      aspectRatio: imageAspectRatio ? imageAspectRatio : [1, 1],
      defaultWidth: defaultWidth ? defaultWidth : 480,
      widths: widths ? widths : [250, 480, 640],
      imgParams: imgParams ? _objectSpread({
        auto: ["format", "compress"]
      }, imgParams) : {
        auto: ["format", "compress"]
      },
      className: className ? className : "story-element-image-gallery__image",
      alt: image.title || story.headline
    }));
  });
  return /*#__PURE__*/React.createElement("div", {
    className: "story-element-image-gallery",
    "data-test-id": "story-element-image-gallery"
  }, images);
}